function featuresNavigation() {
    const featuresWrapper = document.querySelector(".features-navigation");
    const header = document.querySelector(".header");

    if (!featuresWrapper || !header) return;

    const featuresTabs = featuresWrapper.querySelectorAll("li");

    let isScrollingByClick = false;

    const sectionObserver = new IntersectionObserver(
        (entries) => {
            if (isScrollingByClick) return;

            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const sectionId = entry.target.id;
                    featuresTabs.forEach((t) => t.classList.remove("active"));

                    const activeTab = [...featuresTabs].find(
                        (t) => t.dataset.sectionId === sectionId,
                    );
                    if (activeTab) {
                        activeTab.classList.add("active");
                        centerActiveTab(activeTab);
                    }
                }
            });
        },
        {
            rootMargin: `-${header.offsetHeight + featuresWrapper.offsetHeight}px 0px -50% 0px`,
            threshold: 0,
        },
    );

    document
        .querySelectorAll(".section-features")
        .forEach((s) => sectionObserver.observe(s));

    featuresTabs.forEach((tab) => {
        tab.addEventListener("click", function (e) {
            e.preventDefault();
            const sectionId = tab.dataset.sectionId;
            const targetSection = document.querySelector(`#${sectionId}`);

            if (!targetSection) return;

            isScrollingByClick = true;

            featuresTabs.forEach((t) => t.classList.remove("active"));
            tab.classList.add("active");
            centerActiveTab(tab);

            const offset = header.offsetHeight + featuresWrapper.offsetHeight;
            const targetTop =
                targetSection.getBoundingClientRect().top +
                window.scrollY -
                offset;

            window.scrollTo({
                top: targetTop,
                behavior: "smooth",
            });

            setTimeout(() => {
                isScrollingByClick = false;
            }, 1000);
        });
    });
}

featuresNavigation();
